var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.76 35.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c7d6ee;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,29A11,11,0,1,1,29,18c0,.19,0,.38,0,.58l1.32,1.32,5.36-5.38A18,18,0,1,0,18,36a17.74,17.74,0,0,0,6.16-1.09L18.24,29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.44 13.28 44.46 10.28 35.94 18.84 29.68 25.12 27.68 23.12 22.45 17.86 20.05 20.27 17.14 23.19 17.72 23.77 22.1 28.16 27.28 33.37 29.68 35.77 47.44 17.94 49.76 15.6 47.44 13.28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverLogo);
export default __webpack_public_path__ + "static/media/silver-logo.9039956d980bef35aad3c20d963ca123.svg";
export { ForwardRef as ReactComponent };